
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getCustomerList, editParentCustomer, addRegisterCustomer, getCustomerDetail, addCustomerAdmin, delCustomer, qrcode, exportCustomer, batchDownloadqr, getCustomerLimit, relationUser, relationUserList } from '@/api/customer';
import { IPagination } from '@/types';
import { UserModule } from '@/store/modules/user';
import eventBus from "@/utils/eventBus";
import DialogAddCustomer from './components/CustomerAddDialog.vue';
import DialogQr from '@/components/QRDownLoadDialog/QRDownLoadDialog.vue';
import DialogSetImport from '../staff/components/setImport.vue';
import DialogSetStaff from '../staff/components/setStaff.vue';
import DialogSuperiorCustomer from '@/components/CustomerDialog/levelByLevel.vue';
import SearchItem from './components/CustomerSearchCustom.vue';
import { checkPermissionCompany, checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'CustomerList',
  components: {
    DialogAddCustomer,
    DialogQr,
    DialogSetImport,
    DialogSuperiorCustomer,
    DialogSetStaff,
    SearchItem
  }
})
export default class extends Vue {
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private page = 1;
  private size = 10;
  private redText=''
  private listLoading = false;
  private searchParams: any = {};
  private dataTable = []
  private checkAll = false
  private isIndeterminate:any = null
  private selectedbox:any = []
  private dialogAddAlreadyCustomerVisible = false
  private formAddAlreadyCustomer = {
    alreadyType: '1',
    company: '',
    id: '',
    request: ''
  }
  private dialogAddCustomerVisible = false

  private dialogAddManagerVisible = false
  private formAddManager = {
    mobile: '',
    name: '',
    sex: '',
    email: ''
  }
  private dialogAuthDeviceVisible = false
  private isHaveDevice=false;
  private isShowCustomerHistry=false;

  created() {
    this.isHaveDevice = checkPermissionCompany(UserModule.getCompanyId, Type.device);
    this.isShowCustomerHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CustomerHistry);

    let that = this;
    eventBus.$on("customerSearch", (data: any) => {
      that.searchParams = data;
      this.page = 1;
      that.getCustomerList();
    });

    this.getCustomerList();
    this.getCustomerLimit();
  }
  private getRowKey(row: any) {
    return row.customer_company_id;
  }

  beforeDestroy() {
    eventBus.$off("customerSearch");
  }

  handleCurrentChange(size: number) {
    this.page = size;
    this.getCustomerList();
  }

  handlePageSizeChange(size: number) {
    this.size = size;
    this.getCustomerList();
  }

  // 获取列表
  private getCustomerList() {
    this.listLoading = true;
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      page: this.page,
      size: this.size,
      ...this.searchParams,
    // contain_branch: 1
    };
    getCustomerList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.currentPage = parseInt(data.page_current);
          this.pagination.total = parseInt(data.count);
          this.dataTable = data.list;
          this.dataTable.forEach((item:any) => {
            (item as any).hasChildren = parseInt(item.lower_count) > 0;
          });
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.dataTable = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.dataTable = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  // 获取限制红字
  private getCustomerLimit() {
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
    };
    getCustomerLimit(params)
      .then((res: any) => {
        this.redText = '当前版本限制公司客户数量' +
        res.data.customer_company_number +
        '现已添加公司客户' +
        res.data.company_num + '个。现已添加个人客户' +
        res.data.user_num + '个。';
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }
  // 导出Qr
  private handleIportQR() {
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.showErrorMsg('请选择客户');
      return;
    }
    let arr = [];
    for (let index = 0; index < this.selectedbox.length; index++) {
      const element:any = this.selectedbox[index];
      arr.push(element.id);
    }

    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.relation_id = arr.join(',');

    this.$confirm('导出包含所有自己二维码', '提示', {
      confirmButtonText: '是',
      cancelButtonText: '否',
      type: 'warning'
    }).then(() => {
      pamars.is_all_child = '1';
      batchDownloadqr(pamars).then(res => {
        this.$confirm('是否跳转下载页面？', '跳转', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ExportTask',
            query: {}
          });
          window.open(routeData.href);
        }).catch(() => {

        });
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }).catch(() => {
      pamars.is_all_child = '0';
      batchDownloadqr(pamars).then(res => {
        this.$confirm('是否跳转下载页面？', '跳转', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ExportTask',
            query: {}
          });
          window.open(routeData.href);
        }).catch(() => {

        });
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    });
  }

  private handleDIYIportQR() {
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.showErrorMsg('请选择客户');
      return;
    }
    let routeData = this.$router.resolve({
      path: '/CustomerQrcodeDownload',
      query: { customerList: JSON.stringify(this.selectedbox) }
    });
    window.open(routeData.href);
  }

  private customerSuperiorVisible = false
  // 修改上级
  private superiorHandle() {
    if (this.selectedbox.length === 0) {
      this.$notify({
        title: '提示',
        message: '请选择需要修改上级的客户',
        type: 'warning'
      });
      return;
    }
    this.customerSuperiorVisible = true;
  }
  private customerSuperiorClose(val: any) {
    this.customerSuperiorVisible = val;
  }
  private selectCustomerSuperiorHandle(val: any) {
    let ids :any = [];
    this.selectedbox.forEach((item:any) => {
      ids.push(item.id);
    });
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.relation_ids = ids;
    pamars.customer_pid = val.customer_company_id;
    editParentCustomer(pamars).then((res:any) => {
      this.customerSuperiorVisible = false;
      this.showSecussMsg(res.msg);
      this.getCustomerList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 添加客户
  private clickAddAlreadyCustomer() {
    this.formAddAlreadyCustomer = {
      alreadyType: '1',
      company: '',
      id: '',
      request: ''
    };
    this.dialogAddAlreadyCustomerVisible = true;
  }
  private clickAddCustomer() {
    this.addFormData = {};
    this.addType = 1;
    this.dialogAddCustomerVisible = true;
  }
  private sureAddAlreadyCustomer() {
    if (!this.formAddAlreadyCustomer.company && !this.formAddAlreadyCustomer.id) {
      this.showErrorMsg('请输入公司名称或输入唯一ID');
      return;
    }
    this.addRegisterCustomer();
  }
  private sureAddCustomer() {
    this.addCustomer();
  }

  private closeAddCustomer(val: boolean) {
    this.dialogAddCustomerVisible = val;
  }
  private addCustomer() {

  }
  private addCustomerHandle(val: any) {
    this.getCustomerLimit();
    this.getCustomerList();
    if (this.addFormData && this.addFormData.company_pids) {
      this.refDataList(this.addFormData.company_pids, 1, this.addFormData.hasChildren);
    } else {
      this.refDataList(this.addFormData.customer_company_id, 1, this.addFormData.hasChildren);
    }
    if (parseInt(this.addType) === 1 && this.isHaveDevice) {
      if (parseInt(val.customer_type) === 1) {
        this.customerId = val.id + '-1';
      } else {
        this.customerId = val.uid + '-2';
      }
      this.dialogAuthDeviceVisible = true;
    }
  }
  // 添加已注册的客户
  private addRegisterCustomer() {
    let params:any = {};
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.user_id = UserModule.getUserId;
    params.customer_type = this.formAddAlreadyCustomer.alreadyType;
    if (parseInt(this.formAddAlreadyCustomer.alreadyType) === 1) {
      params.name = this.formAddAlreadyCustomer.company;
    } else {
      params.mobile = this.formAddAlreadyCustomer.company;
    }
    params.only_id = this.formAddAlreadyCustomer.id;
    params.remark = this.formAddAlreadyCustomer.request;

    addRegisterCustomer(params).then(res => {
      this.dialogAddAlreadyCustomerVisible = false;
      this.showSecussMsg((res as any).mgs);
      this.getCustomerList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private selectAll:boolean = false;

  private handleSelecAllChange(val:any) {
    if (this.selectAll) {
      this.clearAllRow(val);
    } else {
      this.checkRow(this.dataTable);
    }
    this.selectAll = !this.selectAll;
    this.selectedbox = (this.$refs.tableList as any).selection;
  }

  // 取消选中递归
  private clearAllRow(data:any) {
    Array.from(data).forEach((row:any) => {
      row.isCheck = false;// 给这行数据设置一个选中字段为false
      (this.$refs.tableList as any).toggleRowSelection(row, false);
      if (row.children) this.clearRow(row.children);// 有子集就递归  没子集了就不循环了
    });
  }

  private getLength(m:number, arr:any) {
    m = m + arr.length;
    Array.from(arr).forEach((row:any) => {
      if (row.children) {
        m = this.getLength(m, row.children);
      }
    });
    return m;
  }

  private handleSelectionChange(select:any, row:any) {
    let checkrow = [];
    checkrow.push(row);
    if (row.isCheck) {
      if (select === 1) {
        (this.$refs.tableList as any).toggleRowSelection(row, false);
      }
      this.clearRow(checkrow);
    } else {
      if (select === 1) {
        (this.$refs.tableList as any).toggleRowSelection(row, true);
      }
      this.checkRow(checkrow);
    }
    this.selectedbox = (this.$refs.tableList as any).selection;
  }
  // 取消选中递归
  private clearRow(data:any) {
    Array.from(data).forEach((row:any) => {
      row.isCheck = false;// 给这行数据设置一个选中字段为false
      (this.$refs.tableList as any).toggleRowSelection(row, false);
      // if (row.children) this.clearRow(row.children);// 有子集就递归  没子集了就不循环了
    });
  }
  // 选中递归
  private checkRow(data:any) {
    Array.from(data).forEach((row:any) => {
      row.isCheck = true;// 选中是字段值为true
      (this.$refs.tableList as any).toggleRowSelection(row, true);
      if (row.children) this.checkRow(row.children);
    });
  }
  // 客户详情
  private dialogCustomerDetailVisible = false
  private detailActiveName = 'first'
  private detailCustomer:any=''
  private detailHandle(val:any) {
    this.dialogCustomerDetailVisible = true;
    this.getCustomerDetail(val.id);
  }

  private load(tree:any, treeNode:any, resolve:any) {
    this.listLoading = true;
    const parentId = tree.customer_company_id;
    this.maps.set(parentId, { tree, treeNode, resolve });
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      customer_company_pid: tree.customer_company_id,
      page: 1,
      size: '999999'
    };
    getCustomerList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          let dataTable:any = data.list;
          tree.children = dataTable;
          dataTable.forEach((item:any) => {
            (item as any).hasChildren = parseInt(item.lower_count) > 0;
          });
          resolve(dataTable);
        } else {
          resolve([]);
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.listLoading = false;
        let msg = err.msg;
        resolve([]);
      });
  }

  private tabBeforeHandle(activeName: string, oldActiveName: string) {
    if (activeName === 'third') {
      let routeData = this.$router.resolve({
        path: '/Device/Device/toCustomer',
        query: this.detailCustomer
      });
      window.open(routeData.href);
      return false;
    }
    if (activeName === 'second') {
      let routeData = this.$router.resolve({
        path: '/Record/list',
        query: this.detailCustomer
      });
      window.open(routeData.href);
      return false;
    }
  }

  private handleCheckAllChange(val: boolean) {
    let options: any = [];
    if (val) {
      for (let i = 0; i < this.dataTable.length; i++) {
        options.push((this.dataTable[i] as any));
        if ((this.dataTable[i] as any).child) { // 二级
          for (let m = 0; m < (this.dataTable[i] as any).child.length; m++) {
            options.push((this.dataTable[i] as any).child[m]);
            if ((this.dataTable[i] as any).child[m].child) { // 三级
              for (let n = 0; n < (this.dataTable[i] as any).child[m].child.length; n++) {
                options.push((this.dataTable[i] as any).child[m].child[n]);
                if ((this.dataTable[i] as any).child[m].child[n].child) { // 四级
                  for (let v = 0; v < (this.dataTable[i] as any).child[m].child[n].child.length; v++) {
                    options.push((this.dataTable[i] as any).child[m].child[n].child[v]);
                  }
                }
              }
            }
          }
        }
      }
    } else {
      options = [];
    }
    this.selectedbox = options;
    this.isIndeterminate = false;
  }

  private getCustomerDetail(customerId:string) {
    let params:any = {};
    params.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    params.user_id = UserModule.getUserId;
    params.customer_id = customerId;
    getCustomerDetail(params).then(res => {
      if (res.data) {
        this.detailCustomer = res.data;
      } else {
        this.detailCustomer = '';
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // 二维码
  private dialogQRVisible=false;
  private qrInfo:any={};
  private coustomerQrId='coustomerQrId'
  private QrHandle(row:any) {
    this.qrInfo.customer = row;
    this.qrInfo.servicer = UserModule.getCompanyName;
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.relation_id = row.id;
    pamars.agent_code = row.agent_code;
    pamars.alliance_code = row.alliance_code;
    qrcode(pamars).then(res => {
      this.qrInfo.qrCode = res.data.img_url;
      this.dialogQRVisible = true;
    });
  }
  private closeDialogQr(val:boolean) {
    this.dialogQRVisible = val;
  }
  // 授权导入

  private setImportVisible=false;
  private setImportType=10;
  private setImportTitle='从Excel导入设备';
  private customerId='0'
  private improtAuthDevice(val:any) {
    this.setImportType = 10;
    this.setImportVisible = true;
  }
  private jumpDevice(val:any) {
    let routeData = this.$router.resolve({
      path: '/Device/toDevice',
      query: this.detailCustomer
    });
    window.open(routeData.href);
  }
  private downLoadXLS() {
    window.location.href = process.env.BASE_URL + 'static/frontUserNew/template/import_devices.xlsx';
  }
  closeImport(value: boolean) {
    this.getCustomerLimit();
    this.getCustomerList();
    this.setImportVisible = value;
  }

  private handleBtnClick(name:any, row:any) {
    (this.$options as any).methods[name].bind(this)(row);
  }
  private getBtnMoreData(val: any) {
    let arr = [{
      name: '授权设备',
      funcname: 'authDeviceHandle',
      show: true
    }, {
      name: '关联人员',
      funcname: 'customerRelatedHandle',
      show: true
    }, {
      name: '添加管理员',
      funcname: 'addManagerHandle',
      show: false
    }, {
      name: '添加下级',
      funcname: 'AddLowerhandle',
      show: false
    }, {
      name: '导入客户',
      funcname: 'importHandle',
      show: false
    }, {
      name: '编辑',
      funcname: 'editHandle',
      show: true
    }, {
      name: '删除',
      funcname: 'deleteHandle',
      show: true
    }];
    if (parseInt(val.customer_type) === 1) {
      if (parseInt(val.is_have_admin) !== 1 && parseInt(val.is_many_servicer) !== 1 && val.create_customer_company_id === UserModule.getCompanyId) {
        arr[2].show = true;
      } else {
        arr[2].show = false;
      }
      if (parseInt(val.customer_company_level) !== 4 && parseInt(val.is_many_servicer) !== 1 && val.create_customer_company_id === UserModule.getCompanyId) {
        arr[3].show = true;
        arr[4].show = true;
      } else {
        arr[3].show = false;
        arr[4].show = false;
      }
    }
    if (checkPermissionCompany(UserModule.getCompanyId, Type.RelatedModule)) {
      arr[1].show = true;
    } else {
      arr[1].show = false;
    }
    // if (parseInt(val.state) !== 1) {
    //   arr[5].show = true;
    // } else {
    //   arr[5].show = false;
    // }
    return arr;
  }

  private authDeviceHandle(val:any) {
    if (parseInt(val.customer_type) === 1) {
      this.customerId = val.customer_company_id + '-1';
    } else {
      this.customerId = val.user_id + '-2';
    }
    this.dialogAuthDeviceVisible = true;
  }
  // 关联人员
  private dialogSetStaffVisible = false;
  private selectUsers:any=[]
  private customerRelatedHandle(val:any) {
    this.selectUsers = [];
    this.addFormData = val;
    this.addFormData.company_pids = this.addFormData.company_pids + ',' + this.addFormData.customer_company_id;
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.customer_id = val.id;
    params.size = 9999;
    relationUserList(params).then(res => {
      if (res.data.list) {
        res.data.list.forEach((us:any) => {
          let u:any = {};
          u.id = us.user_id;
          u.name = us.user_name;
          this.selectUsers.push(u);
        });
      }
    });
    this.dialogSetStaffVisible = true;
  }
  closeHandle(value: boolean) {
    this.dialogSetStaffVisible = value;
  }
  private selectUser(val:any) {
    let list:any = [];
    val.forEach((aa:any) => {
      let user:any = {};
      user.id = aa.id;
      user.name = aa.name;
      list.push(user);
    });
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;

    params.customer_id = this.addFormData.id;
    params.customer_company_id = this.addFormData.customer_company_id;
    params.customer_user_id = this.addFormData.customer_user_id;
    params.customer_type = this.addFormData.customer_type;
    params.user_list = JSON.stringify(list);
    relationUser(params).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.dialogSetStaffVisible = false;
      if (this.addFormData && this.addFormData.company_pids) {
        this.refDataList(this.addFormData.company_pids, 1, this.addFormData.hasChildren);
      } else {
        this.refDataList(this.addFormData.customer_company_id, 1, this.addFormData.hasChildren);
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 添加管理员
  private addManagerHandle(val:any) {
    this.customerId = val.customer_company_id;
    this.dialogAddManagerVisible = true;
  }
  private addManager() {
    if (!this.formAddManager.mobile) {
      this.showErrorMsg('请输入手机号');
      return;
    }
    if (this.formAddManager.mobile) {
      var telRegex = /^1\d{10}$/;
      if (!telRegex.test(this.formAddManager.mobile)) {
        this.showErrorMsg('请输入正确的手机号');
        return;
      }
    }
    if (!this.formAddManager.name) {
      this.showErrorMsg('请输入姓名');
      return;
    }
    let customerCompanyId = this.customerId;
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.customer_company_id = customerCompanyId;
    pamars.mobile = this.formAddManager.mobile;
    pamars.name = this.formAddManager.name;
    addCustomerAdmin(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.dialogAddManagerVisible = false;
      this.getCustomerList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 添加下级
  private addType:any=1;
  private addFormData:any={}
  private AddLowerhandle(row:any) {
    this.addType = 3;
    this.addFormData = row;
    this.addFormData.company_pids = this.addFormData.company_pids + ',' + this.addFormData.customer_company_id;
    this.dialogAddCustomerVisible = true;
  }
  // 导出客户统计
  private exportCustomer() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    exportCustomer(pamars).then((res:any) => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 导入客户
  private importCus() {
    this.customerId = '';
    this.setImportType = 12;
    this.setImportVisible = true;
  }
  // 导入下级
  private importHandle(val:any) {
    this.customerId = val.company_id;
    this.setImportType = 12;
    this.setImportVisible = true;
  }
  private editHandle(row:any) {
    this.addFormData = row;
    this.addType = 2;
    this.dialogAddCustomerVisible = true;
  }
  private deleteHandle(row :any) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let params:any = {
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          user_id: UserModule.getUserId,
          relation_id: row.id
        };
        delCustomer(params).then(res => {
          this.showSecussMsg((res as any).msg);
          this.getCustomerLimit();
          this.getCustomerList()
          if (row && row.company_pids) {
            this.refDataList(row.company_pids, 2, row.hasChildren);
          } else {
            this.refDataList(row.customer_company_id, 2, row.hasChildren);
          }
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      })
      .catch(() => {});
  }
  private maps:any = new Map()
  // type 1 = add 2 = delete
  private refDataList(pids:any, type:number, hasChildren:boolean) {
    if (!pids) {
      return
    }
    let list = pids.split(',');
    let _ = this;
    if (list) {
      if (hasChildren) {
        _.refData(list[list.length - 1]);
      } else {
        _.refData(list[list.length - 1]);
        _.refData(list[list.length - 2]);
      }
    }
  }

  private refData(pid:any) {
    if (this.maps.get(pid)) {
      this.$set(((this.$refs.tableList) as any).store.states.lazyTreeNodeMap, pid, []);
      const { tree, treeNode, resolve } = this.maps.get(pid);
      this.load(tree, treeNode, resolve);
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
